import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useBenefisCategoryUIContext } from "../BenefisCategoryUIContext";
import { BenefisCategoryDeleteDialogHeader } from "./BenefisCategoryDeleteDialogHeader";
import { BenefisCategoryDeleteForm } from "./BenefisCategoryDeleteForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/benefisCategory/benefisCategoryAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";

export const BenefisCategoryDeleteDialog = ({ id, show, onHide }) => {
  // BenefisCategory UI Context
  const benefisCategoryUIContext = useBenefisCategoryUIContext();
  const benefisCategoryUIProps = useMemo(() => {
    return {
      initBenefisCategory: benefisCategoryUIContext.initBenefisCategory,
      queryParams: benefisCategoryUIContext.queryParams,
      setQueryParams: benefisCategoryUIContext.setQueryParams,
    };
  }, [benefisCategoryUIContext]);

  // BenefisCategory Redux state
  const dispatch = useDispatch();
  const { actionsLoading, benefisCategoryForEdit, error } = useSelector(
    (state) => ({
      actionsLoading: state.benefisCategory.actionsLoading,
      benefisCategoryForEdit: state.benefisCategory.benefisCategoryForEdit,
      error: state.benefisCategory.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting BenefisCategory by id
    dispatch(actions.fetchBenefisCategory(id));
  }, [id, dispatch]);

  const deleteBenefisCategory = () => {
    dispatch(actions.deleteBenefisCategory(id)).then((response) => {
      toast.success(response.message, toastOption);
      dispatch(
        actions.fetchBenefisCategorys(benefisCategoryUIProps.queryParams)
      ).then(() => onHide());
    });
  };

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="modal-sizes-title-lg">
      <BenefisCategoryDeleteDialogHeader id={id} />
      <BenefisCategoryDeleteForm
        deleteBenefisCategory={deleteBenefisCategory}
        actionsLoading={actionsLoading}
        benefisCategory={
          benefisCategoryForEdit || benefisCategoryUIProps.initBenefisCategory
        }
        onHide={onHide}
      />
    </Modal>
  );
};
